const setAreaOfExpertiseDetachPracticeArea = (id, practiceAreaId) => ({
  type: 'SET_AREA_OF_EXPERTISE_DETACH_PRACTICE_AREA',
  practiceAreaId,
  id,
});

export default setAreaOfExpertiseDetachPracticeArea;
